import React from 'react';
import './Footer.scss';

const Footer = () => {
  const currentYear = new Date().getFullYear()
  return (

    <footer className="d-flex pl-3 pr-3 footer">
      <span>Copyright © AKSSAI ProjExel {currentYear}</span>
    </footer>

  )
};

export default Footer;